import React from 'react';
import ReactDOM from 'react-dom';
import { toODataString } from '@progress/kendo-data-query';
import { ROOT_API_URL, ODATA_API_URL } from '../../../../../api-config';
import axios from 'axios';
import { auth } from '../../../../../services/auth.service';
import { history } from '../../../../../helpers/history';

export class InvoicesLoader extends React.Component {
    baseUrl = `${ODATA_API_URL}/Invoices?$count=true&`;
    init = { method: 'GET', accept: 'application/json', headers: { }  };

    lastSuccess = '';
    pending = '';

    requestDataIfNeeded = () => {
        if (this.pending || toODataString(this.props.dataState) === this.lastSuccess) {
            return;
        }
        this.pending = toODataString(this.props.dataState);
        const t = auth.authHeader();

        this.init.headers = t;
        this.init.headers['Access-Control-Allow-Origin'] = '*';
        this.init.headers['Content-Type'] = 'application/json;charset=UTF-8';

        fetch(this.baseUrl + this.pending, this.init)
            .then(response => response.json())
            .then(json => {
                let as = this.props.dataState;
                this.lastSuccess = this.pending;
                this.pending = '';
                if (toODataString(this.props.dataState) === this.lastSuccess) {
                    this.props.onDataRecieved.call(undefined, {
                        data: json.value,
                        total: json['@odata.count']
                    });
                } else {
                    this.requestDataIfNeeded();
                }
            })
            .catch((response) => {
                console.log(response);
                history.push('/oops')
            });
    }

    render() {
        this.requestDataIfNeeded();
        return this.pending && <LoadingPanel />;
    }
}


class LoadingPanel extends React.Component {
    render() {
        const loadingPanel = (
            <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image"></div>
                <div className="k-loading-color"></div>
            </div>
        );

        const gridContent = document && document.querySelector('.k-grid-content');
        return gridContent ? ReactDOM.createPortal(loadingPanel, gridContent) : loadingPanel;
    }
}